import React, { useRef, useEffect, useState } from 'react';
import styled from 'styled-components';
import {
  sendSsoTokenToIframe,
  setupIframeTokenListener,
} from '../util/iframeJwtUtils';
import { issueSsoToken } from '../request/insidersRequest';
import { getTargetOrigin } from '../security/config';

const PageWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
`;

const IframeContainer = styled.div`
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden;
`;

const StyledIframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
  display: block;
  margin: 0;
  padding: 0;
`;

const InsiderPlusWelcomePage = () => {
  const iframeRef = useRef(null);
  const [ssoToken, setSsoToken] = useState(null);

  useEffect(() => {
    // Fetch SSO token on component mount
    const fetchSsoToken = async () => {
      try {
        const response = await issueSsoToken();
        // Token can be at response.data.ssoToken OR directly at response.data
        const token = response?.data?.ssoToken || response?.data;
        if (token && typeof token === 'string') {
          setSsoToken(token);
        }
      } catch (error) {
        console.error(
          '[InsiderPlusWelcomePage] Error fetching SSO token:',
          error,
        );
      }
    };

    fetchSsoToken();
  }, []);

  useEffect(() => {
    // Setup listener for iframe token requests
    const cleanup = setupIframeTokenListener(
      () => null, // No JWT token for this page
      () => ssoToken,
      getTargetOrigin(),
    );

    return cleanup;
  }, [ssoToken]);

  const handleIframeLoad = () => {
    // Send SSO token to iframe once it's loaded
    if (ssoToken) {
      sendSsoTokenToIframe(iframeRef.current, ssoToken, getTargetOrigin());
    }
  };

  // Use local iframe in development, production in production
  const iframeSrc =
    process.env.NODE_ENV === 'development'
      ? 'http://localhost:3003/welcome'
      : 'https://gs-insiders.lovable.app/welcome';

  return (
    <PageWrapper>
      <IframeContainer data-cy="container-insider-plus-welcome-page">
        <StyledIframe
          ref={iframeRef}
          src={iframeSrc}
          title="Insider Plus Welcome"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          onLoad={handleIframeLoad}
        />
      </IframeContainer>
    </PageWrapper>
  );
};

export default InsiderPlusWelcomePage;
